import React, { Component } from "react";
import { Modal, Form, Input, Select, Button } from "antd";
import ModalTitle from "../shared/ModalTitle/ModalTitle";
import KeywordResearchTabs from "./KeywordResearchTabs";

const { Option } = Select;
const InputGroup = Input.Group;

export default class KeywordResearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      keyword: "",
      seoDb: this.props.seoDb,
      validationError: ""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
  }

  handleInputChange(e) {
    let keyword = e.target.value;
    this.setState({ keyword, validationError: "" });
  }

  handleSelectChange(seoDb) {
    this.setState({ seoDb });
  }

  handleSubmit(e) {
    e.preventDefault();
    let keyword = this.state.keyword.toLowerCase().trim();

    if (!keyword) {
      this.setState({ keyword, validationError: "This field is required!" });
    } else {
      this.setState({ keyword, validationError: "" });
      this.setState(prevState => ({
        visible: !prevState.visible
      }));
    }
  }

  handleCloseModal() {
    this.setState(prevState => ({
      visible: !prevState.visible,
      keyword: ""
    }));
    this.props.onTypeChange(this.props.defaultType);
  }

  onTabChange(activeKey) {
    this.props.onTypeChange(activeKey);
  }

  render() {
    return (
      <React.Fragment>
        <Form className="keyword-research-form" onSubmit={this.handleSubmit}>
          <Form.Item
            validateStatus={this.state.validationError ? "error" : "success"}
            help={this.state.validationError}>
            <InputGroup compact size="large">
              <div className="compact-input-group flex-wrap">
                <div className="double-selector">
                  <label htmlFor="keywordInput">Keyword</label>
                  <Input
                    id="keywordInput"
                    placeholder="Enter a keyword"
                    name="keyword"
                    size="large"
                    value={this.state.keyword}
                    onChange={this.handleInputChange}
                  />
                  <label className="database-label" htmlFor="regionalDatabase">Regional database</label>
                  <Select
                    id="regionalDatabase"
                    size="large"
                    className="no-radius"
                    defaultValue={`${this.state.seoDb} - google.com`}
                    onChange={this.handleSelectChange}
                    loading={this.props.isLoadingSeoDbs}>
                    {this.props.regionalDatabases &&
                      Object.keys(this.props.regionalDatabases).map(regional_db => (
                        <Option key={regional_db}>
                          {regional_db} - {this.props.regionalDatabases[regional_db]}
                        </Option>
                      ))}
                  </Select>
                </div>

                <Button type="primary" htmlType="submit" size="large">
                  Check for Keywords
                </Button>
              </div>
            </InputGroup>
          </Form.Item>
        </Form>

        <Modal
          className="keyword-research-modal"
          title={<ModalTitle title="Keywords suggestions for: " meta={this.state.keyword} />}
          visible={this.state.visible}
          onCancel={this.handleCloseModal}
          footer={null}
          centered
          destroyOnClose>
          <KeywordResearchTabs
            onTabChange={key => this.onTabChange(key)}
            keyword={this.state.keyword}
            seoDb={this.state.seoDb}
            selectedResearchType={this.props.selectedType}
            researchTypes={this.props.allTypes}
          />
        </Modal>
      </React.Fragment>
    );
  }
}
